import React, { useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { NotifySeverity } from '../utils/notify';

interface AppNotifyEvent extends CustomEvent {
  detail: { message: string; severity: NotifySeverity };
}

/**
 * Listens for 'app:notify' custom events (fired by notify() in utils/notify.ts)
 * and displays them as a MUI Snackbar. Mount once at the root of the app.
 */
const GlobalSnackbar = (): JSX.Element => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [severity, setSeverity] = useState<NotifySeverity>('error');

  useEffect(() => {
    const handler = (e: Event) => {
      const { message: msg, severity: sev = 'error' } = (e as AppNotifyEvent)
        .detail;
      setMessage(msg);
      setSeverity(sev);
      setOpen(true);
    };
    window.addEventListener('app:notify', handler);
    return () => window.removeEventListener('app:notify', handler);
  }, []);

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={() => setOpen(false)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={severity}
        onClose={() => setOpen(false)}
        variant="filled"
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default GlobalSnackbar;
